import { ITypedReduxAction } from '../../types/redux/actionType';
import { TPaymentMethods } from '../../types/redux/paymentMethods';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export const SET_PAYMENT_METHODS = 'PAYMENT_WIDGET :: PAYMENT_METHODS :: SET';

export interface ISetPaymentMethodsPayload {
  methods: TPaymentMethods;
  methodIds: Array<string>;
  selectedMethodId: string | null;
}

export type TSetPaymentMethodsAction = ITypedReduxAction<typeof SET_PAYMENT_METHODS, ISetPaymentMethodsPayload>;

export const setPaymentMethods: (payload: ISetPaymentMethodsPayload) => TSetPaymentMethodsAction = actionGenerator<
  typeof SET_PAYMENT_METHODS,
  ISetPaymentMethodsPayload
>(SET_PAYMENT_METHODS);
